<template>
	<div>
		<div class="pb-2" v-if="dataUsed.length == 0">
			<not-found></not-found>
		</div>
		<div class="pr-2 mt-n2" v-else>
			<apexchart type="bar" height="310" :options="chartOptions" :series="salesProduct"></apexchart>
		</div>
	</div>
</template>

<script>
import { mapActions,  mapState } from 'vuex'
import apexchart from 'vue-apexcharts'

export default {
	components: {
		apexchart,
	},
	data() {
		return {
			list: [ {
				name: 'series-1',
				data: [12, 12, 12, 12, 12, 12, 12]
			}
			],
		}
	},
	props: {
		fitur: {
			type: String
		},

	},
	computed: {
		...mapState('dashboardAll', ['listSalesProductWeekly', 'listSalesRetailWeekly']),

		chartOptions () {
			let categories = Object.keys(this.dataUsed.day_arr);
			return {
				chart: {
					type: 'bar',
					toolbar: {
						show: false,
					}
				},
				colors: ['#EF5350', '#8E24AA', '#9FA8DA', '#1565C0', '#006064', '#81C784', '#689F38', '#DCE775', '#E65100', '#8D6E63'],
				plotOptions: {
					bar: {
						horizontal: false,
						columnWidth: '55%',
						endingShape: 'rounded',
						dataLabels: {
							position: 'top',
						},
					},
				},
				legend: {
					horizontalAlign: 'left',
				},
				dataLabels: {
					enabled: true,
					formatter: (val) => {
						if (val)
							return this.$options.filters.toNumber(val)
						else
							return ''
					},
					offsetY: -30,
					style: {
						colors: ["#304758"]
					},
					hideOverflowingLabels: true
				},
				stroke: {
					show: true,
					width: 2,
					colors: ['transparent']
				},
				xaxis: {
					categories: categories,
				},
				yaxis: {
					labels: {
						formatter: (val) => {
							return this.$options.filters.toNumber(val)
						}
					},
				},
				fill: {
					opacity: 1,
				},
				tooltip: {
					y: {
						formatter: function (val) {
							return val + " terjual"
						}
					}
				}
			}
		},
		salesProduct() {
			let data = Object.keys(this.dataUsed.results).map((val) => this.dataUsed.results[val])
			data.forEach(function(val) {
				val.name = val.product_code
				val.data = Object.values(val.quantity)
				delete val.product_code
				delete val.quantity
			})
			return data
		},
		dataUsed() {
			if (this.fitur == 'sales-retail')
				return this.listSalesRetailWeekly
			else
				return this.listSalesProductWeekly
		}
	},
	methods: {
		...mapActions('dashboardAll', ['getSalesProductWeekly', 'getSalesRetailWeekly']),
	},
	created() {
		if (this.fitur == 'sales-retail')
			this.getSalesRetailWeekly()
		else
			this.getSalesProductWeekly()
	}
}
</script>